import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withTranslate } from 'react-redux-multilingual'

import * as actions from '../../../store/actions'

import Aux from '../../../hoc/Auxiliary/Auxiliary'
import Card from '../../../components/UI/Card/Card'
import CardBody from '../../../components/UI/Card/Body/Body'
import CardHeader from '../../../components/UI/Card/Header/Header'

import Alert from '../../../components/Alert/Alert'

import FilterModal from '../../../components/FilterModal/FilterModal'

import { updateFilterOptions, clearFilterOptionValues, updateObject } from '../../../helpers/utils'

import ActionBar from '../../../components/ActionBar/ActionBar'

import ForceRankPageContent from '../../../components/PageContent/VerticalForceRank/ForceRankContent/ForceRankPageContent'

import PleaseFilter from '../../../components/PleaseFilter/PleaseFilter'
import Spinner from '../../../components/UI/Spinner/Spinner'
import PageInfo from '../../../components/PageInfo/PageInfo'

class VerticalForceRank extends Component {
  state = {
    data: [],
    filterData: [],
    filter: {},
    gradeData: [],
    filterModalOpen: false,
    filtered: false,
    filterControls: {
      company_id: {
        label: this.props.translate('company'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('company'),
          options: []
        },
        required: true
      },
      form_id: {
        label: this.props.translate('form'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('form'),
          options: []
        },
        required: true
      },
      fr_group_id: {
        label: this.props.translate('forceRankGroup'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('forceRankGroup'),
          options: []
        },
        required: true
      }
    },

    filterOptions: {
      companyFilterOptions: null,
      formFilterOptions: null,
      orgFilterOptions: null,
      frgFilterOptions: null
    }
  }

  componentDidMount() {
    this.props.fetchAppraisalTypes()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.appraisalType !== this.props.appraisalType) {
      this.props.fetchFilterOptions({
        appraisal_type_id: this.props.appraisalType?.appraisal_type_id
      })
    }
    if (prevProps.success !== this.props.success && this.props.success) {
      window.location.reload(false)
    }
  }

  componentWillUnmount() {
    this.clearFilter()
  }

  static getDerivedStateFromProps(props, state) {
    if (props.filterOptions.companyFilterOptions !== state.filterOptions.companyFilterOptions) {
      const companyFilter = state.filterControls.company_id
      const updateFilterItem = updateFilterOptions(
        props.filterOptions.companyFilterOptions,
        companyFilter,
        'company_id',
        'company_id',
        { name: 'company_name', code: 'company_code' },
        'Select Company'
      )
      return {
        filterControls: updateObject(state.filterControls, { company_id: updateFilterItem }),
        filterOptions: {
          ...state.filterOptions,
          companyFilterOptions: props.filterOptions.companyFilterOptions
        }
      }
    }

    if (props.filterOptions.formFilterOptions !== state.filterOptions.formFilterOptions) {
      const formFilter = state.filterControls.form_id
      const updateFilterItem = updateFilterOptions(
        props.filterOptions.formFilterOptions,
        formFilter,
        'form_id',
        'form_id',
        'form_name',
        'Select Form'
      )
      return {
        filterControls: updateObject(state.filterControls, { form_id: updateFilterItem }),
        filterOptions: {
          ...state.filterOptions,
          formFilterOptions: props.filterOptions.formFilterOptions
        }
      }
    }

    if (props.filterOptions.frgFilterOptions !== state.filterOptions.frgFilterOptions) {
      const frgFilter = state.filterControls.fr_group_id
      const updateFilterItem = updateFilterOptions(
        props.filterOptions.frgFilterOptions,
        frgFilter,
        'fr_group_id',
        'fr_group_id',
        'fr_group_name',
        'Select Force Range Group'
      )
      return {
        filterControls: updateObject(state.filterControls, { fr_group_id: updateFilterItem }),
        filterOptions: {
          ...state.filterOptions,
          frgFilterOptions: props.filterOptions.frgFilterOptions
        }
      }
    }
    if (props.gradeData !== state.gradeTable) {
      let gradeTable = props.gradeData.map(item => {
        return {
          ...item,
          checkAmount: 0,
          budget_percent: 0,
          amount: 0
        }
      })
      return {
        gradeData: gradeTable
      }
    }

    return {
      filterControls: {
        ...state.filterControls
      },
      filterOptions: {
        ...state.filterOptions,
        companyFilterOptions: props.filterOptions.companyFilterOptions
      }
    }
  }

  clearFilter = () => {
    const clearedFilter = clearFilterOptionValues(this.state.filterControls)
    this.setState({
      filterControls: clearedFilter
    })
  }
  openFilterModal = () => {
    this.setState({
      filterModalOpen: true
    })
  }
  closeFilterModal = () => {
    this.setState({
      filterModalOpen: false
    })
  }

  filterChangedHandler = (itemKey, event) => {
    let value = event
    const filterControls = { ...this.state.filterControls }
    const updatedItem = { ...filterControls[itemKey], value }
    const updatedFilterControls = updateObject(filterControls, { [itemKey]: updatedItem })
    const appraisalTypeId = this.props.appraisalType?.appraisal_type_id
    const filterOptions = {
      appraisal_type_id: appraisalTypeId,
      company_id: updatedFilterControls.company_id?.value?.value,
      fr_group_id: updatedFilterControls.fr_group_id?.value?.value
    }

    if (itemKey === 'company_id') {
      this.props.fetchForceRankGroupOptions(filterOptions)
      this.props.fetchFormOptions(filterOptions)
    }

    this.setState({
      filterControls: updatedFilterControls
    })
  }

  filterRecords = (event, page) => {
    let param = {
      company_id: this.state.filterControls.company_id.value.value,
      fr_group_id: this.state.filterControls.fr_group_id.value.value,
      form_id: this.state.filterControls.form_id.value.value
    }
    // this.props.fetchForceRankFilter(param)
    this.setState({
      filtered: true
    })
    this.props.fetchForceRankGrade()
    this.props.fetchVerticalForceRank(param)
    this.closeFilterModal()
  }
  render() {
    let content = <PleaseFilter />

    if (this.state.filtered === true) {
      if (this.props.filterLoading === true) {
        content = <Spinner />
      } else {
        content = (
          <ForceRankPageContent
            data={this.props.data}
            unData={this.props.adjustData?.emp_not_close}
            popCal={this.props.calData}
            adjustData={this.props.adjustData?.grade_table || this.state.gradeData}
            filterControls={this.state.filterControls}
            filterData={this.props.filterData}
            loading={this.props.loading}
            createForceRank={data => {
              this.props.createForceRank(data)
            }}
            fetchForceRankList={param => {
              this.props.fetchForceRankList(param)
            }}
            fetchForceRankCalculate={param => {
              this.props.fetchForceRankCalculate(param)
            }}
            fireAlert={alertOption => {
              this.props.fireAlert(alertOption)
            }}
          />
        )
      }
    }

    return (
      <Aux>
        <FilterModal
          open={this.state.filterModalOpen}
          cancelled={this.closeFilterModal}
          filterSaved={this.filterRecords}
          filterChanged={(itemKey, event) => this.filterChangedHandler(itemKey, event)}
          filterControls={this.state.filterControls}
        />
        <Alert />
        <Card>
          <CardHeader>
            <ActionBar
              filtering={this.openFilterModal}
              show={['filter']}
              leftContent={<PageInfo pageTranslateKey={'forceRankVertical'} />}
            />
          </CardHeader>
          <CardBody>{content}</CardBody>
        </Card>
      </Aux>
    )
  }
}

const mapStateToProps = state => {
  const appraisalType = state.individualAssignment.appraisalTypes.find(item => {
    return item.appraisal_type_code === 'APT02'
  })

  return {
    appraisalType: appraisalType,
    pagination: state.verticalForceRank.pagination,
    filtered: state.verticalForceRank.filtered,
    filterLoadingQueue: state.verticalForceRank.filterLoadingQueue,
    filterData: state.verticalForceRank.filterData,
    filterLoading: state.verticalForceRank.filterLoading,
    // loading: state.verticalForceRank.loading,
    pageLoading:
      state.verticalForceRank.filterLoading || state.verticalForceRank.appraisalTypes.length === 0,
    filterOptions: {
      companyFilterOptions: state.verticalForceRank.filterCompanies,
      formFilterOptions: state.verticalForceRank.filterForms,
      frgFilterOptions: state.verticalForceRank.filterFrgs
    },
    data: state.verticalForceRank.data,
    adjustData: state.verticalForceRank.adjustData,
    gradeData: state.verticalForceRank.gradeData,
    unData: state.verticalForceRank.unData,
    calData: state.verticalForceRank.calData,
    success: state.verticalForceRank.success
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchVerticalForceRank: param => dispatch(actions.fetchVerticalForceRank(param)),
    fetchForceRankList: param => dispatch(actions.fetchVerticalForceRankList(param)),
    createForceRank: data => dispatch(actions.createVerticalForceRank(data)),
    fetchForceRankGrade: param => dispatch(actions.fetchVerticalForceRankGrade(param)),
    // fetchForceRankFilter: filterOptions => dispatch(actions.fetchVerticalForceRankFilter(filterOptions)),
    fetchForceRankCalculate: param => dispatch(actions.fetchVerticalForceRankCalculate(param)),
    fireAlert: alertOption => {
      dispatch(actions.enqueueSnackbar(alertOption))
    },
    fetchAppraisalTypes: () => {
      dispatch(actions.fetchAppraisalTypeOptions())
    },
    fetchFilterOptions: filterOptions => {
      dispatch(actions.fetchCompanyOptionsForAppraisal(filterOptions))
    },
    fetchFormOptions: filterOptions => {
      dispatch(
        actions.fetchFormOptionsForAppraisal({
          ...filterOptions,
          is_force_rank: 1
        })
      )
    },
    fetchForceRankGroupOptions: filterOptions => {
      dispatch(actions.fetchForceRankGroupOptions(filterOptions))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(VerticalForceRank))
